<template>
  <div>
    <div class="card mb-3 w-100">
      <p class="card-titulo font-weight-bold p-2 h5"> 
        Sangria de Caixa
      </p>
      <div class="card-conteudo mr-3 ml-3">
        <div v-for="dados in dadosDoCard" 
             :key="dados.titulo" 
             class="d-flex justify-content-between align-items-center mb-3">
          <span class="w-50">
            {{ dados.titulo }}
          </span>
          <div class="card-valor font-weight-bold text-left">
            <input v-money="money"
                   :value="dados.valor"
                   disabled
                   size="sm"
                   trim>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import { VMoney } from 'v-money'

  export default {
    name: "CardTipoDePagamento",
    directives: {
      money: VMoney
    },
    props: {
      propTipoPg: {type: Object, default: () =>{}},
    },
    data () {
      return {
        dadosDoCard: [],
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2, 
          masked: false
        },
      }
    },
    computed: {
      cxSaldo () {
        return this.$store.state.frenteCaixa.saldo
      },
      caixaStore () {
        return this.$store.state.frenteCaixa.caixa
      },
    },
    watch: {
      'cxSaldo.pedidos.saldoTotal' () {
        this.init()
      }
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        const saldoInicial = this.cxSaldo.pedidos.saldoAnterior
        this.dadosDoCard = []
        this.dadosDoCard.push(this.cxSaldo.sangriaCx.sangriaEntrada)
        this.dadosDoCard.push(this.cxSaldo.sangriaCx.sangriaSaida)
        this.dadosDoCard.push({titulo: 'Saldo ínicial', valor: saldoInicial})        
      }
    }

  }
</script>

<style scoped>
    .card {
        box-shadow: 3px 3px 0px rgba(0, 0, 0, 0.3);
    }
    .card .card-titulo {
        background-color: #C6C6C6;
    }
    .card .card-conteudo .card-valor{
        font-size: 1.3rem;
    }
    /* .card-valor input {
      font-size: 1.3rem;
      font-weight: bold;
      width:200px;
      padding-left:70px;
    } */
    .card-valor input {
      font-size: 1.3rem;
      font-weight: bold;
      text-align: right;
      margin-right: 20px;
      width:100%;
    }
</style>